<ng-content select=[icon]></ng-content>

<!-- Media Body -->
<div class="media-body">
    <span class="d-block text-light-gray f-12 mb-1">{{label}}</span>
    <ng-content select=[text]></ng-content>
</div>
<!-- /media body -->

